import * as React from 'react';
import styled from 'styled-components';
import { Text } from 'components';
import { Button } from '@bb/elements-web';

type BuyerAppointmentsPrintProps = {
  handleCheck: any;
  hasConfirmedAppointments: boolean;
};

const BuyerAppointmentPrint: React.FC<BuyerAppointmentsPrintProps> = ({
  handleCheck,
  hasConfirmedAppointments,
}) => (
  <BuyerAppointmentPrintContainer>
    <StyledHeaderText>Print buyer showings</StyledHeaderText>
    <HorizontalLine />
    {hasConfirmedAppointments && (
      <StyledCheckboxContainer>
        <input type="checkbox" onChange={handleCheck} />
        <StyledCheckboxText>Show Access Details on report</StyledCheckboxText>
      </StyledCheckboxContainer>
    )}
    <Button
      dataCy="print-showings-button"
      onClick={(window as Window).print}
      styleOverride={{ width: '100%' }}
    >
      <StyledText>Print</StyledText>
    </Button>
  </BuyerAppointmentPrintContainer>
);

const BuyerAppointmentPrintContainer = styled.div.attrs({
  className: 'hidden-print',
})`
  width: 300px;
  max-width: 300px;
  display: inline-block;
  height: 200px;
  padding: 24px;
  background-color: white;
`;

const HorizontalLine = styled.hr`
  background-color: #f5f5f5;
  height: 1px;
  border: none;
  /* override global style for <hr> component */
  margin-top: 10px !important;
`;

const StyledCheckboxContainer = styled.div`
  margin-bottom: 18px;
`;

const StyledCheckboxText = styled(Text)`
  font-weight: 400;
  font-size: 16px;
  margin-left: 8px;
`;

const StyledHeaderText = styled(Text)`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
`;

const StyledText = styled(Text)`
  color: white;
  font-weight: 700;
  font-size: 17px;
`;

export default BuyerAppointmentPrint;
